import { HOME_DEPOT_HOSTNAME, HOME_DEPOT_STATIC_HOSTNAME } from '../constants/Constants';

export const getBehrBannerInfo = (getConfigService) => {
  const redirectLink = getConfigService('ColorWallBehrLink') || `${HOME_DEPOT_HOSTNAME}/b/Featured-Products-Paint-Paint-Colors-BEHR-2026-COLOR-TRENDS/N-5yc1vZ2fkpcl5`;
  const image = getConfigService('ColorWallBehrImage') || `${HOME_DEPOT_STATIC_HOSTNAME}/promo-banner/2026-behr-color-trends.png`;
  return {
    image,
    redirectLink
  };
};

export const getGliddenBannerInfo = (getConfigService) => {
  const redirectLink = getConfigService('ColorWallGliddenLink') || `${HOME_DEPOT_HOSTNAME}/b/Featured-Products-Paint-Paint-Colors-Glidden-2025-Color-Trends/N-5yc1vZ2fkpfgc`;
  const image = getConfigService('ColorWallGliddenImage') || `${HOME_DEPOT_STATIC_HOSTNAME}/promo-banner/desktop/2025-glidden-trends.png`;

  return {
    image,
    redirectLink
  };
};